<template>
    <div class="rodemap">
        <div class="mask05"></div>
        <QuestionSelect :data="data" @jump="jump" @finish="finish"></QuestionSelect>
    </div>
</template>

<script>
    //script
    import Tools from '../../../scripts/tools';
    import {gsap} from 'gsap';
    //Global
    import Global from '../../../scripts/Global';

    import QuestionSelect from '../../cmp/questionSelect';

    export default {
        data() {
            return {
                data: {
                    // headTipImg: '苏尚卿讲解',
                    headTipTxt: '哎呦去去去，别在这儿添乱今天是元旦你都不知道，快走远些吧！',
                    headTipPathTxt: '前往御景亭 >>',
                    headTipPath: '/rodemap/aj/07',

                    sideImg: '公公npc',
                    sideCfg: {
                        bottom: '-1rem',
                        left: '-0.8rem',
                        transform: 'scale(0.6)',
                    },
                    qText:
                        '哎呦喂，你们还在这闲晃什么？知道今儿什么日子么？一会儿皇上就要来这儿拈香行礼了！',
                    errText:  '哎呦喂，你们还在这闲晃什么？知道今儿什么日子么？一会儿皇上就要来这儿拈香行礼了！',
                    // qImg: 'qImg',
                    answerArr: [
                        {
                            txt: '元旦',
                            right: true
                        },
                        {
                            txt: '端午',

                        },
                    ],
                },
            };
        },
        components: {
            QuestionSelect,
        },
        created() {
            Global.pauseAll();
        },
        computed: {},
        methods: {
            finish(event) {
                if (event) {
                    Global.curr = {
                        ...this.data,
                        headTipImg: '小太监小头像',
                        headTipTxt: '哎呦不错，这个拿着。二位是小情侣吧？去连理柏那拍个照就走吧，别耽误皇上祈福。',
                        headTipPath: '/rodemap/aj/07_5',
                        headTipPathTxt: '前往合影 >>',
                        ybtxt:'',
                        bg: '钦安殿',
                    };
                    Global.yubi.aj.b3 = true;
                    this.$router.replace('/yu');
                } else {
                    // this.$router.replace('/rodemap/ssq/08');
                }
            },
            jump(event) {
                if (event) {
                } else {
                    this.$router.replace('/rodemap/aj/07');
                }
                console.log(event, 'event');
            },
        },
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .rodemap {
        background-image: url(//cdn.original-fun.com/gugong/钦安殿.jpg);
        background-position: center;
        width: 100vw;
        height: 100vh;
        max-width: 75vh;
        margin: 0 auto;
        overflow: hidden;
        background-size: cover;
        background-repeat: no-repeat;
    }
</style>
